import { useState } from 'react';
import axios from 'axios';

// N-097: ключ администратора больше НЕ хранится во фронтенде. Логин уходит на бэкенд
// (POST /admin/login) с паролем, в ответ приходит короткоживущий admin-токен, который
// кладём в localStorage['adminKey'] и шлём как X-Admin-Key (имя заголовка не менялось).
const API = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

export default function Login() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (loading) return;
    setError('');
    setLoading(true);
    try {
      const r = await axios.post(`${API}/admin/login`, { password });
      localStorage.setItem('adminKey', r.data.admin_token);
      window.location.href = '/dashboard';
    } catch (e) {
      setError(e.response?.data?.detail || 'Не удалось войти');
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <span style={styles.logoText}>Refero</span>
          <span style={styles.logoSub}>Панель администратора</span>
        </div>
        <input
          style={styles.input}
          type="password"
          placeholder="Пароль администратора"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleLogin()}
        />
        {error && <div style={styles.error}>{error}</div>}
        <button style={styles.btn} onClick={handleLogin} disabled={loading}>
          {loading ? 'Вход…' : 'Войти'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  card: { background: '#1e293b', borderRadius: 16, padding: 40, width: 360, display: 'flex', flexDirection: 'column', gap: 16 },
  logo: { display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 8 },
  logoText: { fontSize: 32, fontWeight: 700, color: '#2EC4B6', letterSpacing: -1 },
  logoSub: { fontSize: 13, color: '#64748b', marginTop: 2 },
  input: { padding: '12px 16px', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, fontSize: 14, color: 'white', outline: 'none' },
  btn: { background: '#2EC4B6', color: 'white', border: 'none', padding: '13px', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer' },
  error: { background: '#450a0a', border: '1px solid #dc2626', color: '#fca5a5', padding: '10px 14px', borderRadius: 8, fontSize: 13 },
};